import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { BetsPopup } from '../account/betsPeriod';
import BetsSellingModal from '~/components/account/BetsSellingModal';
import Modal, { ModalContainer } from '../modal';
import UnderHeader from "../underHeader";
import {get} from 'lodash';

@withRouter
@inject('accountStore', 'lineStore', 'dictStore')
@observer
export default class Settings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSettings: false,
      showBets: false
    };
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  displayTooltip() {
    if (this.props.lineStore.basket.odds.size !== 0) {
      this.hideTooltip();
      return;
    }
    const accountSettings = this.props.accountStore.settings || { is_basket_tooltip_visible: 1 };
    // TODO КОСТЫЛЬ: 1 - значит подсказка была показана
    if (accountSettings.is_basket_tooltip_visible === 1) {
      return;
    }
    ReactTooltip.show(this.basketTooltipRef);
  }

  componentDidMount() {
    this.displayTooltip();
    document.addEventListener('mousedown', this.onClickOutside);
  }

  componentDidUpdate() {
    this.displayTooltip();
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onClickOutside);
  }

  onClickOutside = (e) => {
    if (this.basketTooltipRef === e.target) { return; }
    this.hideTooltip();
  }

  hideTooltip() {
    this.props.accountStore.toggleAccountSettings('is_basket_tooltip_visible', 1);
    ReactTooltip.hide(this.basketTooltipRef);
    document.removeEventListener('mousedown', this.onClickOutside);
  }

  toggleAllLeague = () => {
    this.props.lineStore.line.toggleAllLeagueShow();
  };

  toggleSettings = () => {
    this.setState({showSettings: !this.state.showSettings});
  };

  toggleMenu = () => {
    this.props.lineStore.setShortMenu();
  };

  toggleBasket = () => {
    this.props.lineStore.basket.setShowBasket();
  };

  render() {

    if (!this.props.lineStore.line) return false;

    const {shortMenu} = this.props.lineStore;
    const {getLang} = this.props.dictStore;
    const {accountSettings, isBetSellModalOpened} = this.props.accountStore;
    const basketData = this.props.lineStore.basket.basketData;
    const oddsIds = get(basketData, 'oddsIds');
    const {toogleBasket} = this.props.lineStore.basket;
    return (
      <div className="control-panel">
        <ReactTooltip clickable />
        {accountSettings.basketPosition == 'right' ?
          <div className="basket-right-cp fl_r "
            data-tip={getLang('FRONT_TOOLTIP_UNION_BASKET_NEWBASKET')}
            ref={ref => (this.basketTooltipRef = ref)}
            data-multiline="true"
            data-event-off="none"
            data-event="none"
            data-place="left"
            data-type="light"
            data-border-color="black"
            data-effect="solid">
            {toogleBasket.showArrow ?
              <div className={`basket-bets-lurk ${!toogleBasket.showBasket ? 'b-b-l' : ''}`}
                   onClick={this.toggleBasket}>
                <span className="f-s-ico-arrow_buttom_1"></span>
              </div>
              : ''}
            <div className="basket-bets-count-item active basket-bets-count-item-border">
              <span className="fl_l">{getLang('BASKET')}</span>
              {oddsIds.size ? <span className="fl_r basket-count-bet">{oddsIds.size}</span> : ''}
            </div>
            <Count/>
            {isBetSellModalOpened ? <BetsSellingModal/> : null}
          </div>
          : ''}
        <div className="control-panel-layer">
          <a
            className={`control-panel-item line-left-menu-toggle ${shortMenu && accountSettings.basketPosition == 'right' ? 'line-left-menu-toggle-short' : ''}`}
            title="Свернуть меню" onClick={this.toggleMenu}>
                    <span className="control-panel-ico control-panel-ico-menu f-s-ico-menu">
                    </span>
            <span className="control-panel-ico control-panel-ico-toggle f-s-ico-arrow_left">

                    </span>
            <span className="control-panel-text">Свернуть меню</span>
          </a>
          <UnderHeader type={1}/>
          <div className="clearfix"></div>
        </div>
      </div>
    )
  }
}

@inject('accountStore', 'dictStore')
@observer
class Count extends Component {

  state = {
    showBets: false
  };

  toggleBets = () => {
    if (this.props.accountStore.access) {
      this.setState({showBets: !this.state.showBets});
    } else {
      this.props.accountStore.toggleLoginForm(1);
    }
  };

  render() {
    const {getLang} = this.props.dictStore;
    const {countBets} = this.props.accountStore;
    return (
      <Fragment>
        <div onClick={this.toggleBets} className="basket-bets-count-item">
          <span className="fl_l">{getLang('BETS')}</span>
          <span className="fl_r basket-count-bet">{countBets ? countBets : ''}</span>
        </div>
        {this.state.showBets ?
          <ModalContainer>
            <Modal
              styleModal={{width: '800px'}}
              show={this.state.showBets}
              onCloseModal={this.toggleBets}
              title={getLang('IRM_BETS_STATUS_2')}
              //footer={0}
              //closeButton={1}
            >
              <BetsPopup/>
            </Modal>
          </ModalContainer>
          : null}
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/settingsLine/index.js